export default {
  AUTOCOMPLETE_DEBOUNCE_TIME: 1500,
}
